import { request } from "../utils/request.js"

export const expRequest_addNew = (pojo, args) => request({
    url: 'expRequest/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/expRequest.js